import { HttpFiles } from "src/http/files/httpFiles"
import {EntityWithIdFields} from "../../../../types/baseEntities";
import {HttpActivityFile} from "../../../../http/onboarding/httpOnboardingActivity";
import {FileBase, FileBaseFields} from "../../../../types/solicitation/solicitationFile";
import React, {useContext, useEffect, useState} from "react";
import {ActivityFile} from "../../../../types/activity/activityFile";
import BaseDialogTitle from "../../../../components/dialog/BaseDialogTitle";
import {DownloadIconButton, SearchIconButton} from "../../../../components/buttons/Buttons";
import {Alert, Button, Dialog, DialogContent, Skeleton, Stack} from "@mui/material";
import Typography from "@mui/material/Typography";
import {fileFormatter} from "../../../../utils/formatters/fileFormatter";
import Divider from "@mui/material/Divider";
import DialogPreviewFile from "../../../../components/dialog/DialogPreviewFile";
import AddIcon from "@mui/icons-material/Add";
import NewFileDialog from "../../../../components/dialog/NewFileDialog";
import {CompanyContext, CompanyContextValue} from "../../../solicitation-new/context/companyContext";


interface SolicitationTaskFilesDialogProps {
    taskId: number,
    taskPendant: boolean,
    open: boolean,
    onClose: () => void
}


const SolicitationTaskFilesDialog = ({taskId, taskPendant, open, onClose}: SolicitationTaskFilesDialogProps) => {
    const [files, setFiles] = useState<ActivityFile[]>()
    const [loading, setLoading] = useState<boolean>(false)
    const [fileName, setFileName] = useState<string>()
    const [fileBlob, setFileBlob] = useState<any>()
    const [openPreview, setOpenPreview] = useState<boolean>(false)
    const [openNew, setOpenNew] = useState<boolean>(false)
    const { clientId } = useContext<CompanyContextValue>(CompanyContext)

    const loadFiles = () => {
        setLoading(true)
        HttpActivityFile.getList(taskId).then((r) => {
            setFiles(r)
        }).finally(() => setLoading(false))
    }


    useEffect(() => {
        if (taskId !== 0) {
            loadFiles()
        }
    }, [taskId])

    const onNewFile = () => {
        setOpenNew(true)
    }
    
    const onSubmitNew = (fileBase?: FileBase, file?: File, fileId?: number) => {
        return HttpActivityFile.insertFile(taskId, fileBase, file, fileId)
    }
     

    const onDownloadFile = (fileToDownload: FileBase) => {
        HttpFiles.download(fileToDownload[EntityWithIdFields.Id])
            .then((data) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));

                const link = document.createElement('a');
                link.href = downloadUrl;

                link.setAttribute('download', fileToDownload.descArchivo);

                document.body.appendChild(link);
                link.click();
                link.remove();
            });
    }

    const onClosePreview = () => {
        setFileBlob(undefined)
        setOpenPreview(false)
    }

    const onPreviewFile = (file: ActivityFile) => {
        setFileName(file[FileBaseFields.FileDesc])
        setLoading(true)

        HttpFiles.download(file[EntityWithIdFields.Id]).then((data) => {
            setFileBlob(data)
            setLoading(false)
            setOpenPreview(true)
        })
    }
    
    return (
        <Dialog open={open}
                onClose={onClose}
                maxWidth={'md'}
                fullWidth
                aria-labelledby="form-dialog-title"
        >
            <BaseDialogTitle onClose={onClose} title={`Archivos relacionados a la tarea #${taskId}`} />
            <DialogContent>
                <Stack spacing={1}>
                    {
                        loading ?
                            Array.from({length: 5}).map((d, k) => <Skeleton key={k}/>)
                            :
                            <>
                                <Stack direction='row' alignItems={'center'} justifyContent={'space-between'} mt={2} mb={2}>
                                    <Typography fontSize={16} fontWeight={500} mb={2}>Archivos subidos</Typography>
                                    {
                                        taskPendant &&
                                        <Button variant={'contained'} color={'primary'} startIcon={<AddIcon />} onClick={onNewFile} size='small'>
                                            Nuevo
                                        </Button>
                                    }
                                </Stack>
                                {files && files.length !== 0 ?
                                    <Stack spacing={1}>
                                        <Divider />
                                        {files.map((file, idx) =>
                                            <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} key={idx}>
                                                <Stack direction={'row'} alignItems={'center'} spacing={2}>
                                                    {fileFormatter.getIconByFileName(file[FileBaseFields.FileDesc], {fontSize: 'small'})}
                                                    <Stack>
                                                        <Typography fontSize={14} fontWeight={500}>{file[FileBaseFields.FileDesc]}</Typography>
                                                        <Typography fontSize={10} fontWeight={500} color={'text.disabled'}>{`Tipo: ${file[FileBaseFields.FileTypeDesc]}`}</Typography>
                                                    </Stack>
                                                </Stack>
                                                <Stack direction={'row'} alignItems={'center'} spacing={2}>
                                                    <SearchIconButton onClick={() => {onPreviewFile(file)}} size={'small'} tooltipTitle={'Previsualizar'}/>
                                                    <DownloadIconButton size={'small'} onClick={() => {onDownloadFile(file)}} tooltipTitle={'Descargar'}/>
                                                </Stack>
                                            </Stack>
                                        )}
                                    </Stack>
                                    :
                                    <Alert severity={'info'}>No se adjuntaron archivos para esta actividad</Alert>
                                }
                            </>
                    }
                </Stack>
            </DialogContent>
            {
                fileBlob && fileName &&
                <DialogPreviewFile open={openPreview}
                                   onClose={onClosePreview}
                                   fileBlob={fileBlob}
                                   fileName={fileName}
                />
            }
            {
                openNew &&
                <NewFileDialog open={openNew}
                               onClose={() => {setOpenNew(false)}}
                               clientId={clientId}
                               onNewFile={onSubmitNew}
                               fileType={36}
                               onReload={loadFiles}
                />
            }
        </Dialog>
    )
}


export default SolicitationTaskFilesDialog